import { Link } from 'react-router-dom';

export default function TermsConditionsView() {
  return (
    <main className="privacidad-view">
      <header className="header">
        <div className="container">
          <h1>Términos y Condiciones del Servicio</h1>
          <p>TimeTaxSupport (TTS) - Tax Technology S.A.C.</p>
        </div>
      </header>

      <div className="container">
        <div className="content-grid">
          <aside className="toc">
            <h3>Contenido</h3>
            <ul>
              <li>
                <a href="#acuerdo">Acuerdo y Condiciones</a>
              </li>
              <li>
                <a href="#servicios">1. Servicios</a>
              </li>
              <li>
                <a href="#suscripciones">2. Suscripciones y Usuarios</a>
              </li>
              <li>
                <a href="#version-prueba">3. Versión de Prueba y Funciones Beta</a>
              </li>
              <li>
                <a href="#divulgaciones">4. Divulgaciones y Uso de Datos</a>
              </li>
              <li>
                <a href="#acceso-servicio">5. Acceso al Servicio</a>
              </li>
              <li>
                <a href="#cancelacion">6. Cancelación</a>
              </li>
              <li>
                <a href="#redes-sociales">7. Redes Sociales</a>
              </li>
              <li>
                <Link to="/login">
                  <span className="politicas-de-privacidad">Regresar al inicio de sesión</span>
                </Link>
              </li>
            </ul>
          </aside>

          <article className="article">
            <section id="acuerdo" className="section">
              <h2>Acuerdo y condiciones del servicio de TimeTaxSupport</h2>

              <p>
                Gracias por elegir TimeTaxSupport ("TTS"). Este contrato de licencia, además de las Condiciones de servicio de TaxTech (el "Acuerdo"), es un acuerdo legal entre una entidad legal única identificada en el proceso de registro proporcionado como parte del proceso inicial ("Usuario",
                "tú") y Tax Technology S.A.C. ("TaxTech", "nosotros", "nuestro" o "nos").
              </p>

              <p>
                Al seleccionar "ACEPTO", indicas que ha leído y comprendido las condiciones de este Acuerdo y que aceptas que son vinculantes para ti. Si la persona que selecciona "ACEPTO" trabaja para ti ("Representante"), es ella quien acepta los términos y condiciones de este Acuerdo en tu nombre
                y quien declara y garantiza a TaxTech que goza de plenas facultades y autoridad para celebrar este Acuerdo en tu nombre.
              </p>

              <p>
                Si no aceptas los términos del Acuerdo, no se te concederá ningún derecho en relación con los Servicios. Si no estás dispuesto a aceptar la naturaleza vinculante de estos términos y condiciones, no debes seleccionar "ACEPTO" y no podrás acceder ni utilizar de ningún modo los
                Servicios de TTS.
              </p>
            </section>

            <section id="servicios" className="section">
              <h2>1. SERVICIOS</h2>

              <p>En este Acuerdo, se hace referencia a cada uno de los siguientes productos y servicios como "Servicio" y a todos conjuntamente como "Servicios".</p>

              <h3>1.1. TimeTaxSupport</h3>
              <p>
                TimeTaxSupport ("TTS") es una solución en línea para negocios que permite registrar actividades, los sustentos de la realización y liquidar dichas actividades a través de una cuenta en línea (cada una de ellas una "Cuenta de TTS"). Cada Cuenta de TTS solo se puede usar para un único
                negocio.
              </p>

              <h3>1.2. Modificación de los Servicios</h3>
              <p>
                Nos reservamos el derecho, a nuestra entera discreción, de revisar, actualizar o modificar los Servicios o modificar tu acceso a los Servicios; en el caso de cambios significativos, te daremos aviso en la medida en que sea razonablemente posible, ya sea mediante la publicación en el
                sitio web que alberga los Servicios o a la dirección de correo electrónico del Administrador (tal como se define a continuación). Ten en cuenta que podemos modificar la cantidad de espacio de almacenamiento de la que dispones a través de los Servicios y el número de veces (y la
                duración máxima) que puedes acceder a los Servicios en un período de tiempo determinado. En el caso de que debamos mantener la seguridad del sistema o cumplir con las leyes o normativas, nos reservamos el derecho a modificar los Servicios de inmediato y enviar al Administrador un
                aviso electrónico o por escrito dentro de los treinta (30) días posteriores a las modificaciones sustanciales. Para rechazar cambios en los Servicios, puedes interrumpir el uso de los Servicios con los que se relacionan dichos cambios. Si continúas usando los Servicios, significa que
                aceptas y estás de acuerdo con estos cambios.
              </p>
            </section>

            <section id="suscripciones" className="section">
              <h2>2. SUSCRIPCIONES Y USUARIOS</h2>

              <p>La licencia del Servicio de TTS se otorga a través de una suscripción mensual o anual, a elección tuya o de tu representante.</p>
            </section>

            <section id="version-prueba" className="section">
              <h2>3. VERSIÓN DE PRUEBA Y FUNCIONES BETA</h2>

              <p>
                De vez en cuando, TaxTech puede, a su entera discreción, incluir funciones beta nuevas o actualizadas ("Funciones beta") en el Servicio de TTS, de modo que puedas usarlas y te permitan hacer comentarios (se pueden aplicar tasas). Entiendes y aceptas que el uso de las Funciones beta
                es voluntario e TaxTech no tiene ninguna obligación de ofrecerte este tipo de funciones. Entiendes que, una vez que utilices las Funciones beta, es posible que puedas volver a la versión no beta anterior de la misma función o de una similar. Asimismo, en el caso que la reversión no
                sea posible, existe la posibilidad de que no puedas recuperar o restaurar los datos que creaste dentro de la Función beta a la versión no beta anterior. Las Funciones beta se ofrecen "tal cual" y pueden contener errores o inexactitudes que podrían causar fallos, corrupción o pérdida
                de datos o información desde cualquier dispositivo conectado. Reconoces y aceptas que el uso de las Funciones beta es bajo tu propio riesgo.
              </p>
            </section>

            <section id="divulgaciones" className="section">
              <h2>4. DIVULGACIONES Y USO DE DATOS PERMITIDOS</h2>

              <p>
                Reconoces y aceptas que, a fin de brindarte la posibilidad de acceder a los Servicios de TTS, es posible que TaxTech proporcione tu información de acceso y los datos de tu cuenta (i) al empleado o representante que esté identificado en los datos de registro como el administrador
                actual de tu cuenta en el sistema (el "Administrador actual"), y (ii) a cualquier otro empleado o representante que puedas designar como administrador suplente de la cuenta siguiendo los procedimientos que exige TaxTech para efectuar tal reemplazo. Cualquier otra persona que hayas
                identificado como usuario autorizado de los Servicios de TTS tendrá acceso a los datos de la cuenta en función de los permisos de acceso que tú o el administrador del sistema le hayan asignado.
              </p>
            </section>

            <section id="acceso-servicio" className="section">
              <h2>5. ACCESO AL SERVICIO DE TTS, USO Y ALMACENAMIENTO</h2>

              <p>
                TaxTech tendrá el derecho, a su entera discreción y con aviso razonable publicado en el sitio del Servicio de TTS o enviado a la dirección de correo electrónico del Administrador actual indicado en los Datos de registro, a revisar, actualizar o modificar de cualquier otro modo el
                Servicio de TTS y establecer o modificar límites respecto al uso del Servicio de TTS, de manera temporal o permanente. Puedes rechazar los cambios interrumpiendo el uso del Servicio de TTS con el que se relacionan estos cambios. Si continúas usando los Servicios de TTS, significa que
                aceptas estos cambios y estás de acuerdo con ellos. De vez en cuando, TaxTech puede realizar tareas de mantenimiento sobre el Servicio de TTS y provocar interrupciones, retrasos o errores en el servicio. Si bien TaxTech intentará avisar con antelación sobre el mantenimiento
                programado, no puede garantizar que lo hará.
              </p>
            </section>

            <section id="cancelacion" className="section">
              <h2>6. CANCELACIÓN</h2>

              <p>
                Después de la cancelación, podrás acceder al Servicio de TTS únicamente hasta que termine el período de suscripción, tal como se especifica en el producto o en las páginas del programa del producto Una vez terminado el período de suscripción, no tendrás acceso al Servicio de TTS. No
                se realizará ningún reembolso en caso de cancelación. Sigue las instrucciones del producto para cancelar tu cuenta.
              </p>
            </section>

            <section id="redes-sociales" className="section">
              <h2>7. REDES SOCIALES</h2>

              <p>
                TaxTech puede proporcionar experiencias en plataformas de redes sociales como Facebook®, Twitter® y LinkedIn®, que permiten el intercambio y la colaboración entre todas las personas que se hayan registrado para usarlas. El contenido que publiques, como imágenes, información,
                opiniones o cualquier Información personal que reveles a los otros usuarios de estas plataformas sociales, está sujeto a las Condiciones de uso y las Políticas de privacidad de estas plataformas. Consulta estas plataformas de redes sociales para comprender mejor tus derechos y
                obligaciones con respecto al contenido mencionado.
              </p>
            </section>
          </article>
        </div>
      </div>

      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Tax Technology S.A.C. Todos los derechos reservados.</p>
        </div>
      </footer>
    </main>
  );
}
